function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 4h8V2H8v2z",
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 11a2 2 0 00-2 2H4v2h5a2 2 0 002 2h2a2 2 0 002-2h5v-2h-5a2 2 0 00-2-2h-2zm0 2h2v2h-2v-2z",
  fill: "#4038FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 8a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V8zm18 0H4v12h16V8z",
  fill: "#4038FF"
});

var SvgWorkingGroup = function SvgWorkingGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggNEgxNlYySDhWNFoiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSAxMUM5Ljg5NTQzIDExIDkgMTEuODk1NCA5IDEzSDRWMTVIOUM5IDE2LjEwNDYgOS44OTU0MyAxNyAxMSAxN0gxM0MxNC4xMDQ2IDE3IDE1IDE2LjEwNDYgMTUgMTVIMjBWMTNIMTVDMTUgMTEuODk1NCAxNC4xMDQ2IDExIDEzIDExSDExWk0xMSAxM0gxM1YxNUgxMVYxM1oiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDhDMiA2Ljg5NTQzIDIuODk1NDMgNiA0IDZIMjBDMjEuMTA0NiA2IDIyIDYuODk1NDMgMjIgOFYyMEMyMiAyMS4xMDQ2IDIxLjEwNDYgMjIgMjAgMjJINEMyLjg5NTQzIDIyIDIgMjEuMTA0NiAyIDIwVjhaTTIwIDhMNCA4VjIwSDIwVjhaIiBmaWxsPSIjNDAzOEZGIi8+Cjwvc3ZnPgo=";
export { SvgWorkingGroup as ReactComponent };